<template>
  <!-- корневой div держит классы консюмеров (напр. .cloud), PopoverRoot не рендерит DOM -->
  <div class="dropdown" :class="type">
    <PopoverRoot v-model:open="showDialog">
      <PopoverTrigger class="dropdown-toggle drop_down" type="button">
        <span class="title">
          <Favicon v-if="type === 'domain'" :domain="title" class="favicon" />
          <Flag v-if="type === 'country'" :country="title" />
          {{ title }}
        </span>
        <span v-if="divider" class="divider"></span>
        <div class="arrow" :class="{ show: showDialog }">
          <img v-if="type === 'domain'" :src="ArrowWhiteIcon" />
          <img v-else :src="ArrowGrayIcon" />
        </div>
      </PopoverTrigger>
      <!-- закрываемся по любому клику внутри меню — так же вёл себя bootstrap.
           Важно: без класса dropdown-menu, иначе глобальный keydown-хендлер
           bootstrap перехватывает ESC/стрелки и падает -->
      <PopoverContent
        as="ul"
        class="drop_down_dialog dialog"
        side="bottom"
        align="start"
        :side-offset="2"
        :collision-padding="8"
        @click="showDialog = false"
      >
        <slot name="items"></slot>
      </PopoverContent>
    </PopoverRoot>
  </div>
</template>

<script>
import { PopoverRoot, PopoverTrigger, PopoverContent } from 'reka-ui'
import ArrowGrayIcon from '@/assets/icons/base/arrow-gray.svg'
import ArrowWhiteIcon from '@/assets/icons/base/arrow-white.svg'
import Favicon from '@/components/shared/Favicon.vue'
import Flag from '@/components/shared/Flag.vue'

export default {
  data() {
    return {
      showDialog: false,
      ArrowGrayIcon,
      ArrowWhiteIcon,
    }
  },
  components: {
    PopoverRoot,
    PopoverTrigger,
    PopoverContent,
    Favicon,
    Flag,
  },
  props: {
    type: {
      type: String,
      default: 'origin', // domain
    },
    divider: {
      type: Boolean,
      default: false,
    },
    title: String,
  },
}
</script>

<style lang="css" scoped>
.favicon {
  margin-right: 7px;
}

.divider {
  padding: 1px 0 1px 1px;
  margin-right: 12px;
  margin-left: -3px;
  background: var(--border-color-2);
}

.dropdown {
  position: relative;
  z-index: 10;
}

.dropdown.domain {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 11rem;
}

button .title {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 6px;
}

.dropdown.domain > .dropdown-toggle {
  background: none;
  border-radius: 7px;
  padding: 8px 17px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  background-color: var(--main-color);
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.2s ease-out;
}

.dropdown.origin,
.dropdown.country {
  border: 1px solid var(--border-color);
  border-radius: 7px;
}

.dropdown.origin > .dropdown-toggle,
.dropdown.country > .dropdown-toggle {
  justify-content: center;
  outline: none;
  box-shadow: none;
  background: none;
  padding: 7px 15px 8px;
}

.dropdown.origin > .dropdown-toggle span,
.dropdown.country > .dropdown-toggle span {
  margin-right: 15px;
}

.dropdown > .dropdown-toggle:hover {
  cursor: pointer;
}

.dropdown > .dropdown-toggle > .icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dropdown > .dropdown-toggle > .arrow {
  display: inline-block;
}

.dropdown > .dropdown-toggle > .arrow img {
  display: inline-block;
  transition: all 0.3s ease-out;
  position: relative;
}

.dropdown .arrow.show img {
  transform: rotate(180deg);
  padding-top: 2px;
}

.dropdown .dropdown-toggle::after {
  display: none;
}

@media (max-width: 666px) {
  .dropdown.domain {
    width: 10em;
  }
}
</style>

<!-- контент меню рендерится внутри обёртки поппера Reka, scoped-атрибут
     на него не попадает — поэтому стили глобальные -->
<style>
ul.drop_down_dialog {
  min-width: var(--reka-popper-anchor-width, 100%);
  list-style: none;
  margin: 0;
  padding: 5px;
  background: var(--bg-surface);
  border: 1px solid var(--border-color);
  border-radius: 7px;
  box-shadow: var(--shadow-soft);
  font-weight: normal;
  font-size: 1rem;
  max-height: 290px;
  overflow-y: auto;
}

ul.drop_down_dialog::-webkit-scrollbar,
ul.drop_down_dialog::-webkit-scrollbar-thumb {
  width: 10px;
  border-radius: 50px;
  background-clip: padding-box;
  border: 3px solid var(--bg-surface);
}

ul.drop_down_dialog::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
}

@media (max-width: 666px) {
  ul.drop_down_dialog {
    width: 10em;
  }
}
</style>
